import styled from "styled-components";

export const ResetPwPg = styled.div`
  height: calc(100vh - 150px);
  background-color: black;
  position: relative;
  color: white;
  overflow-y: auto;

  .top-graphic {
    width: 85%;
  }

  h2 {
    font-size: 2.2em;
    font-weight: 600;

    @media only screen and (max-width: 600px) {
      font-size: 1em;
    }
  }

  h5 {
    font-weight: 700;
  }

  form {
    margin: 0 auto;
  }

  label {
    font-weight: 600;
    font-size: 0.75em;
  }

  input {
    border-radius: 10px;
    padding: 10px;
    border: none;
    outline: none;
    background-color: #1a1c21d9;
    color: white;
    width: 50%;

    @media only screen and (max-width: 600px) {
      width: 100%;
    }
  }

  input::placeholder {
    text-transform: uppercase;
    font-style: italic;
    text-align: center;
  }

  button {
    text-transform: uppercase;
    font-weight: 600;
    width: 50%;

    @media only screen and (max-width: 600px) {
      width: 100%;
    }
  }

  p {
    font-size: 0.75em;
  }
`;
